import { Box, Button } from '@usap/uicomponents'
import styled from 'styled-components'

export const OrderDetailsButtonContainer = styled(Box)`
  padding-top: 3px;
  padding-bottom: 3px;

  > div {
    margin-top: 15px;
  }
`

export const OrderDetailsGrayButton = styled(Button)`
  width: 300px;
  height: 40px;
  border: 2px solid #acacac;
  background-color: #acacac;
  border-radius: 32px;

  :hover {
    background-color: #6d6d6d;
    border: 2px solid #6d6d6d;
  }

  :disabled {
    opacity: 1;
    cursor: not-allowed;
    border: 2px solid #acacac;
    background-color: #acacac;
  }

  @media screen and (max-width: 992px) {
    width: 100%;
  }
`

export const OrderDetailsBlueButton = styled(Button)`
  width: 300px;
  height: 40px;
  background-color: #2e4787;
  border: 2px solid #2e4787;
  border-radius: 32px;
  cursor: pointer;

  :hover {
    background-color: #3557b1;
    border: 2px solid #3557b1;
  }

  @media screen and (max-width: 992px) {
    width: 100%;
  }
`
